export default __webpack_public_path__ + "static/vue-sviluppo-custom-cbf9b018da5f2a71e3b8e6d53ba60bb1.jpg";